export const Breakpoints = {
	mobile: '(max-width: 575.98px)',
	mobileLandscape: '(max-width: 767.98px)',
	tablet: ' (max-width: 991.98px)',
	desktop: '(max-width: 1199.98px)',
	xldesktop: '(min-width:1200px)'
};

export const POPPER_CONFIG = {
	MARGIN: 16
};
